import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Card, Image, Modal } from "react-bootstrap";
import { connect, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { translate, t } from "react-multi-lang";
import {
    fetchSingleEventStart,
    createPaymentIntentStart
} from "../../store/actions/EventAction";
import { fetchUserDetailsStart } from "../../store/actions/UserAction";
import { fetchCardDetailsStart } from "../../store/actions/CardsAction";
import { useParams } from "react-router-dom";
import moment from "moment";
import "./EventDetails.css"
import configuration from "react-global-configuration";
import CheckoutLoader from "../Loader/CheckoutLoader";
import BookingForm from "./BookingForm"

const CheckoutPage = (props) => {
    const { eventId } = useParams();
    const [showPayment, setShowPayment] = useState(false);
    const [booking, setBooking] = useState({
        name: "",
        email: "",
        number_of_persons: 1,
        event_id: eventId,
        ticket_price: props.singleEvent?.data?.ticket_price,
        user_id: localStorage.getItem("userId")
    });

    const isEmpty = (obj) => {
        return Object.keys(obj).length === 0 && obj.constructor === Object;
    };

    useEffect(() => {
        props.dispatch(fetchSingleEventStart({ event_id: eventId }));
        props.dispatch(fetchCardDetailsStart());
        props.dispatch(fetchUserDetailsStart());
    }, []);

    useEffect(() => {
        if (props.profile?.data && !props.profile?.loading) {
            const userName = props.profile.data.name || props.profile.data.username || "";
            const userEmail = props.profile.data.email || "";
            setBooking((prev) => ({
                ...prev,
                name: userName,
                email: userEmail,
            }));
        }
    }, [props.profile?.data, props.profile?.loading]);

    const handleBookingChange = (field, value) => {
        setBooking({ ...booking, [field]: value });
    };

    const handleCheckout = async (e) => {
        try {
            e.preventDefault();
            setShowPayment(true);
        } catch (error) {
            console.error("Checkout error:", error);
        }
    };

    const handleClose = () => {
        setShowPayment(false);
    };

    useEffect(() => {
        if (props.singleEvent.data?.ticket_price) {
            setBooking((prev) => ({
                ...prev,
                ticket_price: props.singleEvent.data.ticket_price
            }));
        }
    }, [props.singleEvent.data?.ticket_price]);

    const isLoading = props.singleEvent?.loading || props.profile?.loading || !booking.email;

    return (
        <div className="notification-page">
            <Container>
                <div className="profile-post-area">
                    <div className="bookmarkes-list bookmarks-right-side resp-sapce-center">
                        <div className="pull-left">
                            <Link className="bookmarkes-list notify-title" to={`/event/${eventId}`}>
                                <Image
                                    src="/assets/images/icons/back.svg"
                                    className="svg-clone mr-2"
                                />

                                Booking & Checkout
                            </Link>
                        </div>
                    </div>
                </div>

                {isLoading ? (
                    <CheckoutLoader />
                ) : !isEmpty(props.singleEvent.data) ? (
                    <Row className="mb-5">
                        {/* Event Info */}
                        <Col md={5} sm={12} lg={5} xl={5}>
                            <Card className="event-sidebar mm-2">
                                <Card.Body>
                                    <Card.Img variant="top" src={props.singleEvent.data.event_image} className="event-checkout-img" />
                                    <h3 className="mb-3 mt-3">{props.singleEvent.data.title}</h3>
                                    <p>
                                        <i className="fas fa-lg fa-calendar-alt mr-3" />
                                        <span className="meta-text">{moment(props.singleEvent.data.start_datetime).format("ddd, MMM DD YYYY")}</span>
                                    </p>
                                    <p>
                                        <i className="fas fa-lg fa-clock mr-3" />
                                        <span className="meta-text">
                                            {moment(props.singleEvent.data.start_datetime).format("h:mm A")}</span>
                                    </p>
                                    <p>
                                        <i className="fas fa-tags mr-3" />
                                        <span className="meta-text">{props.singleEvent.data?.event_category}</span>
                                    </p>
                                    <p className="d-flex">
                                        <i className="fas fa-lg fa-map-marker-alt mr-4 mt-2" />
                                        <span className="meta-text">{props.singleEvent.data?.venue}</span>
                                    </p>
                                    <hr />
                                    <div className="d-flex justify-content-between align-items-end">
                                        <p className="event-price-detail">
                                            <span className="text-primary">{"$" + props.singleEvent.data?.ticket_price}</span>
                                        </p>
                                    </div>
                                    <p className="event-price-detail mt-2">
                                        {props.singleEvent.data?.show_remaining_tickets == 1 &&
                                            <span className="text-danger">{props.singleEvent.data?.remaining_tickets > 0 ? props.singleEvent.data?.remaining_tickets + " Tickets Left" : "Sold Out"} </span>
                                        }
                                    </p>


                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Ticket & Checkout Form */}
                        <Col md={7} sm={12} lg={7} xl={7}>
                            <Card className="event-sidebar mm-2">
                                <Card.Header> <h4>Booking Details</h4></Card.Header>
                                <Card.Body>
                                    <Form onSubmit={handleCheckout} >
                                        <Form.Group className="mb-2">
                                            <Form.Label>Username: (*)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={booking.name}
                                                autoComplete="off"
                                                disabled required
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-2">
                                            <Form.Label>Email: (*)</Form.Label>
                                            <Form.Control
                                                type="email"
                                                value={booking.email}
                                                autoComplete="off"
                                                disabled
                                                required
                                            />
                                        </Form.Group>

                                        {/* Ticket Count */}
                                        <Form.Group className="mb-4">
                                            <Form.Label>Number of Tickets: (*)</Form.Label>
                                            <Form.Control
                                                as="select"
                                                value={booking.number_of_persons}
                                                autoComplete="off"
                                                onChange={(e) =>
                                                    handleBookingChange("number_of_persons", e.target.value)
                                                }
                                            >
                                                {[1, 2, 3, 4].map((num) => (
                                                    <option key={num} value={num}>
                                                        {num}
                                                    </option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>
                                        <div className="total-amount d-flex justify-content-between">
                                            <strong>Total Amount: </strong> <h3 className="text-danger"
                                            >${(booking.ticket_price * booking.number_of_persons).toFixed(2)}</h3>
                                        </div>
                                        <hr />
                                        {props.singleEvent.data?.remaining_tickets >= booking.number_of_persons ?
                                            <div className="text-right h-auto w-auto">
                                                <Button className="post-btn"
                                                    type="submit">Confirm & Checkout</Button>
                                            </div> : <div className="alert alert-danger" role="alert">Tickets not available.</div>}
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                ) :
                    (<Row>
                        <Col md={12} sm={12} lg={12} xl={12}>
                            {t("event_details_not_exist")}
                        </Col>
                    </Row>)
                }
            </Container>

            {showPayment && (
                <BookingForm onClose={handleClose} props={props} booking={booking} />
            )}
        </div >
    );
}

const mapStateToPros = (state) => ({
    singleEvent: state.event.singleEvent,
    session: state.event.session,
    cards: state.cards.cardDetails,
    profile: state.users.profile,
});

function mapDispatchToProps(dispatch) {
    return { dispatch };
}

export default connect(
    mapStateToPros,
    mapDispatchToProps
)(translate(CheckoutPage));